import { Link } from '@tanstack/react-router';
import { ChevronLeft } from 'lucide-react';

interface SettingsSubPageHeaderProps {
  title: string;
  description?: string;
}

/**
 * Shared header for a Settings hub sub-page (Billing, Campaign preferences, …):
 * a back link to the hub landing, the page title, and an optional supporting
 * line. Keeps the sub-pages consistent and is the single place their chrome
 * changes.
 */
export function SettingsSubPageHeader({ title, description }: SettingsSubPageHeaderProps) {
  return (
    <div>
      <Link
        to="/app/settings"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ChevronLeft className="h-4 w-4" />
        Settings
      </Link>
      <h1 className="text-2xl font-bold tracking-tight mt-2">{title}</h1>
      {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
    </div>
  );
}
